import { createGlobalStyle } from 'styled-components';

const SuccessStyles = createGlobalStyle`
.success-page {
  background: #f6f6f6;
  height: 100%;
  overflow-y: auto;
}

.success-container {
  height: 100%;
}

.success-container .container-fluid {
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.success-page .success-container .main-content {
  flex: 1;
  margin-top: -32px;
  padding: 0px 20px 0px;
  background: radial-gradient(
    101.47% 46.86% at 50% 50%,
    #ffdada 0%,
    #ffffff 100%
  );
  overflow: hidden;
  padding-bottom: 134px;
}

.success-page .success-container .main-content .icon-wp {
  width: 100%;
  height: auto;
  margin: auto;
}

.success-page .success-container .main-content .icon-wp img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.success-page .success-container .main-content .message {
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #ffffff;
  box-shadow: 0px 12px 12px rgba(255, 0, 0, 0.04);
  backdrop-filter: blur(6px);
  border-radius: 16px;
  padding: 32px;
  width: fit-content;
  margin: auto;
  margin-top: -80px;
  text-align: center;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #6f7072;
}

.success-page .success-container .main-content .message .title {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #00d764;
  margin-bottom: 12px;
}

.success-page .success-container .main-content .btns-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin: auto;
  margin-top: 46px;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  max-width: unset;
  padding: 20px;
}

.success-page .success-container .main-content .btns-section > * {
  flex: 1;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-decoration: none;
  padding: 12px 24px;
}

.success-page .success-container .main-content .btns-section button a {
  display: block;
  height: 100%;
  width: 100%;
}

.success-page
  .success-container
  .main-content
  .btns-section
  button
  a:hover,
.success-page
  .success-container
  .main-content
  .btns-section
  button
  a:active:focus {
  text-decoration: none;
}

@media screen and (min-width: 576px) {
  .success-container {
    height: calc(100% - 60px);
  }

  .success-page .success-container .main-content .icon-wp {
    max-width: 466px;
  }

  .success-page .success-container .main-content .message {
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #ffffff;
    box-shadow: 0px 12px 12px rgba(255, 0, 0, 0.04);
    backdrop-filter: blur(6px);
    border-radius: 16px;
    padding: 32px;
    width: fit-content;
    margin: auto;
    margin-top: -70px;
    text-align: center;
    font-weight: 300;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: #6f7072;
  }

  .success-page .success-container .main-content .message .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 36px;
    text-align: center;
    color: #00d764;
    margin-bottom: 12px;
  }

}

@media screen and (min-width: 769px) {
  .success-container .container-fluid {
    min-height: 100%;
  }

  .success-page .success-container .main-content {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.02), 0px 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 32px 32px 0px 0px;
    padding: 24px;
    overflow: hidden;
    margin-top: 32px;
  }

  .success-page .success-container .main-content .icon-wp {
    width: 466px;
    height: 466px;
    margin: auto;
    margin-top: -100px;
  }

  .success-page .success-container .main-content .icon-wp img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .success-page .success-container .main-content .message {
    margin-top: -65px;
  }

  .success-page .success-container .main-content .message .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 36px;
    text-align: center;
    color: #00d764;
    margin-bottom: 12px;
  }

  .success-page .success-container .main-content .btns-section {
    position: relative;
  }

  .success-page .success-container .main-content .btns-section > * {
    max-width: 335px;
  }
}

@media screen and (max-width: 768px) {
  .success-container .container-fluid {
    padding: 0;
  }
}

@media screen and (max-width: 576px) {
  .main-content .title {
    margin-top: 52px;
  }
}

.message-welcome {
  border-radius: 16px;
  padding: 32px;
  width: fit-content;
  margin: auto;
  text-align: center;
  font-weight: 300;
  font-size: 20px;
  line-height: 28px;
  color: #6f7072;
  margin-top: 40px;
}

`;

export default SuccessStyles;
